import React, {useContext, useState} from "react";
import moment from "moment";
import Account from "../../../stories/_account/Accounts/Account";
import authController from "../../../stories/_auth/Auth/AuthController";
import LogoutIcon from "../../icons/LogoutIcon";
import UserIcon from "../../icons/UserIcon";
import SessionContext from "../../../context/SessionContext";
import "../../../css/page/UserPreview.css";
import "moment/locale/fr";
moment.locale("fr");

const UserPreview = props => {
    const {setAccountForm, setPasswordForm} = props;
    const {handleLogout} = useContext(SessionContext);
    const [showOptions, setShowOptions] = useState(false);
    const env = JSON.parse(localStorage.getItem("env"));
    const user = new Account(JSON.parse(localStorage.getItem("user")));

    const buildUserName = () => {
        if (localStorage.getItem("user") === null) return "-";
        return user.fullname;
    }
    const handleShowOptions = () => {
        setShowOptions(!showOptions);
    }
    const handleAccountForm = () => {
        setShowOptions(false);
        setAccountForm();
    }
    const handlePasswordForm = () => {
        setShowOptions(false);
        setPasswordForm();
    }

    return (
        <>
            <div className={"UserPreview " + env.type} onClick={handleShowOptions}>
                <UserIcon classname={"icon"} />
                <p className={"name"}>{buildUserName()}</p>
            </div>
            {
                showOptions
                && <div className={"userOptions"}>
                    <p className={"email"}>{ user.email }</p>
                    <p className={"rules"}>{ authController.listMyRules() }</p>
                    <nav className={"list"}>
                        <p className={"item"} onClick={handleAccountForm}>Modifier mes informations</p>
                        <p className={"item"} onClick={handlePasswordForm}>Modifier mon mot de passe</p>
                        <div className={"logout"} onClick={handleLogout}>
                            <p className="name">Déconnexion</p>
                            <LogoutIcon />
                        </div>
                    </nav>
                </div>
            }
        </>
    );
}

export default UserPreview;